"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castelplanio": {
    "4f2a531f": [{
      "hkey": "84bcc3cc",
      "slug": "borgo-loreto-macine",
      "name": "Borgo Loreto-Macine",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-loreto": [{
      "hkey": "84bcc3cc",
      "slug": "borgo-loreto-macine",
      "name": "Borgo Loreto-Macine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "575b7185": [{
      "hkey": "84bcc3cc",
      "slug": "borgo-loreto-macine",
      "name": "Borgo Loreto-Macine",
      "primary": true,
      "skipSearch": false
    }],
    "macine": [{
      "hkey": "84bcc3cc",
      "slug": "borgo-loreto-macine",
      "name": "Borgo Loreto-Macine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "castelplanio"
    }]
  }
};
exports["default"] = _default;